import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp4};
`

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: ${props => props.theme.stroke.default} solid
    ${props => (props.isActive ? props.theme.colors.outline.default : props.theme.colors.border.default)};
  border-radius: 6px;
  background-color: ${props => (props.isActive ? props.theme.colors.outline.default : props.theme.colors.text.inverse)};
  color: ${props => (props.isActive ? props.theme.colors.text.inverse : props.theme.colors.outline.default)};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${props => props.theme.colors.outline.default};
  }
`
